export const getMyAddress = ({cancelToken}) => {
  return {method: 'GET', endpoint: `/api/auth/address/mine`, cancelToken};
};

export const updateMyAddress = payload => {
  return {method: 'PATCH', endpoint: `/api/auth/address`, data: payload};
};
